import {
  keyring_env,
  env,
  sponsorshipPolicyIds,
  accountType,
} from "./constants"
import {
  LitAuthProvider,
  KeyringController,
  WalletController,
  WalletType,
  AaDetails,
  FeeController,
} from "@tria-sdk/web-test"
import { AuthController } from "@tria-sdk/core-test"
import { IRelayPKP } from "../types"
import { LitCustomAuthMethod } from "@tria-sdk/web-test/types"
import io from "socket.io-client"
const baseUrl = process.env.REACT_APP_BASE_URL || ""
const stytchProjectId =
  "project-test-33cdb822-9ede-4a46-963d-3fccfd302e03" || ""
const stytchSecretId = "secret-test-hKpHxQTrpFOQdOjYHvZ5y6yaSxOq7wg0ccs=" || ""
export const pimlicoApiKey = "af86d1ab-0dc4-4be7-96eb-ce9fc9fd48c0" // test aa flow on polygon
// const sponsorshipPolicyId = "sp_cheerful_thing";

export const socket = io(process.env.REACT_APP_SOCKET_URL || "")

const walletType: WalletType = {
  embedded: true,
  supportAa: true,
}

const walletControllerInstance = ( aa? : AaDetails) => {
  const currentAccountString = localStorage.getItem("currentAccount")
  const sessionSignaturesString = localStorage.getItem("initSession")
  const customAuthMethodString = localStorage.getItem("customAuthMethod")

  if (!currentAccountString || !customAuthMethodString) {
    console.log("please login again.....")
    throw new Error("please login again.....")
  }

  // Parse the currentAccount string to IRelayPKP or set it as undefined
  const currentAccount: IRelayPKP = currentAccountString
    ? JSON.parse(currentAccountString)
    : undefined

  const customAuthMethod: LitCustomAuthMethod =
    customAuthMethodString ? JSON.parse(customAuthMethodString) : undefined

  const sessionSignatures: string | undefined = sessionSignaturesString
    ? JSON.parse(sessionSignaturesString)
    : undefined

  const walletController = new WalletController({
    baseUrl,
    walletType,
    currentAccount,
    sessionSignatures,
    customAuthMethod: customAuthMethod,
    selectedWallet: aa?.supportAa ? "AA":"EOA",
    aa
  })
  return walletController
}

const feeControllerInstance = ( aa?: AaDetails) => {
  const currentAccountString = localStorage.getItem("currentAccount")
  const sessionSignaturesString = localStorage.getItem("initSession")
  const customAuthMethodString = localStorage.getItem("customAuthMethod")

  if (!currentAccountString || !customAuthMethodString) {
    console.log("please login again.....")
    throw new Error("please login again.....")
  }

  // Parse the currentAccount string to IRelayPKP or set it as undefined
  const currentAccount: IRelayPKP = currentAccountString
    ? JSON.parse(currentAccountString)
    : undefined

  const customAuthMethod: LitCustomAuthMethod =
    customAuthMethodString ? JSON.parse(customAuthMethodString) : undefined

  const sessionSignatures: string | undefined = sessionSignaturesString
    ? JSON.parse(sessionSignaturesString)
    : undefined

    const feeController = new FeeController({
      baseUrl,
      walletType,
      selectedWallet: aa?.supportAa ?"AA":"EOA",
      currentAccount,
      customAuthMethod: customAuthMethod,
      aa
    })
  return feeController
}


export { walletControllerInstance }
export { feeControllerInstance }
export const authContoller = new AuthController(
  baseUrl,
  stytchProjectId,
  stytchSecretId
)

// const sessionSignatures=localStorage.getItem("initSession") ||'';
// const currentAccount=localStorage.getItem("pkp");

// console.log("sessionSignatures->",sessionSignatures,currentAccount);

const currentAccountString = localStorage.getItem("currentAccount")
  const customAuthMethodString = localStorage.getItem("customAuthMethod")

const keyringController = new KeyringController({
  baseUrl,
  walletType,
  //@ts-ignore
  currentAccount: JSON.parse(currentAccountString),
  //@ts-ignore
  customAuthMethod: JSON.parse(customAuthMethodString),
  sentryDns:
    "https://7fb9e6916137b5d5e9fcd5a141d1cb96@o4505837187366912.ingest.sentry.io/4505837198442496",
  environment: keyring_env as typeof env,
  aa: {
    accountType: accountType,
  },
})

export const litController = new LitAuthProvider(
  stytchProjectId,
  baseUrl,
  walletType,
  { accountType }
)

export default keyringController
